import { createContext } from "react";

export const CreatePerkModalContext = createContext();